module.exports = __webpack_public_path__ + "static/media/kh.3efd7621.svg";